import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect } from 'react';
import { Translate } from 'react-jhipster';
import { Alert, Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { getLatestTireGrooves } from './tire-groove-custom.reducer';

const TireGrooveCustom = () => {
  const dispatch = useAppDispatch();

  const loading = useAppSelector(state => state.tireGrooveCustom.loading);
  const tireTruckImplement = useAppSelector(state => state.tireTruckImplementCustom.entities);
  const tireGrooves = useAppSelector(state => state.tireGrooveCustom.entities);

  useEffect(() => {
    if (tireTruckImplement.length > 0) {
      const tireIds = tireTruckImplement.map(tti => tti?.tire?.id);
      dispatch(getLatestTireGrooves(tireIds));
    }
  }, [tireTruckImplement]);

  return (
    <Box>
      {tireGrooves && tireGrooves.length > 0 ? (
        <TableContainer>
          <Table size="small" sx={{ fontSize: '0.75rem', '& td, & th': { fontSize: '0.75rem' } }}>
            <TableHead>
              <TableRow>
                <TableCell>Pneu</TableCell>
                <TableCell>Posição</TableCell>
                <TableCell>
                  <Translate contentKey="fleetSenseApp.tireGroove.groove">Groove</Translate>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...tireGrooves]
                .sort(
                  (a, b) =>
                    (tireTruckImplement.find(tti => tti.tire?.id === a.tire?.id)?.position ?? 0) -
                    (tireTruckImplement.find(tti => tti.tire?.id === b.tire?.id)?.position ?? 0)
                )
                .map((tireGroove, i) => (
                <TableRow key={`entity-${i}`} data-cy="entityTable" hover>
                  <TableCell>{tireTruckImplement.find(tti => tti.tire?.id === tireGroove.tire?.id)?.tire?.marking ?? tireGroove.tire.identificationCode}</TableCell>
                  <TableCell>
                    <Chip label={tireTruckImplement.find(tti => tti.tire?.id === tireGroove.tire?.id)?.position} size="small" />
                  </TableCell>
                  <TableCell>{tireGroove.groove}mm</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150 }}>
          <Typography>Aguarde, carregando...</Typography>
        </Box>
      ) : (
        <Alert severity="warning">
          <Translate contentKey="fleetSenseApp.tireGroove.home.notFound">No Tire Grooves found</Translate>
        </Alert>
      )}
    </Box>
  );
};

export default TireGrooveCustom;
